import { Trans } from 'react-i18next';
import React from 'react';
import classNames from 'classnames/bind';

import { GOOGLE_PLAY_DOWNLOAD_COUNT } from 'constants/values';

import { Button, Image, Text } from 'libComponents';
import FixedWrapper from 'components/FixedWrapper';

import styles from './ObSocialProofLibContainer.module.css';

import { IObSocialProofContainer } from './types';

const cx = classNames.bind(styles);

function ObSocialProofLibContainer({ toNextPage, content, smallSubTitle }: IObSocialProofContainer) {
    const subtitleClasses = cx('subTitle', { smallSubTitle });

    return (
        <div className={styles.container}>
            <Text color="primary-default" bold type="h1" center mb={16}>
                <Trans
                    i18nKey={content.translateKey}
                    values={{ count: content.count || GOOGLE_PLAY_DOWNLOAD_COUNT, age: content.age }}
                    components={{ span: <span className={subtitleClasses} /> }}
                />
            </Text>
            <div className={styles.imgWrapper}>
                <Image src={content.imgData} alt="socialGroup" />
            </div>
            <div className={styles.adaptationWrapper}>
                <FixedWrapper>
                    <Button className={styles.continueButton} dataLocator="obContinue" onClick={toNextPage} text={content.buttonData.text} mb={20} />
                </FixedWrapper>
            </div>
        </div>
    );
}

export default ObSocialProofLibContainer;
